import axios from 'axios';
import { USER_SERVICE_K8S_URL, USER_SERVICE_CLIENT_ID, USER_SERVICE_CLIENT_NAME } from './server-config';
import { handleAxiosException } from './error-handler';
import { UserAuthenticationInfo } from './server-auth';

const devUser = {
  username: 'dangr',
  id: process.env.SAUCE_USER_ID || 'd88a0de366364b7fb08c96cee9aa75f7',
  first_name: 'Solaire',
  last_name: 'Astora',
  user_type: 'free-trial',
  organization: {
    id: 'dev-user',
    settings: {
      sso_enabled: false,
    },
  },
};

export const USER_TYPES = {
  FREE: 'free',
  FREE_TRIAL: 'free-trial',
  SUBACCOUNT: 'subaccount',
  FREEMIUM: 'freemium',
  ADMIN: 'admin',
};

const userServiceHeaders = {
  headers: {
    'SL-AUTH-CLIENT-ID': USER_SERVICE_CLIENT_ID,
    'SL-AUTH-HOST-HEADER': USER_SERVICE_CLIENT_NAME,
    'Content-Type': 'application/json',
  },
};

export async function fetchUserV1(username: string, doNotLogError: boolean | ((a: any) => boolean) = false): Promise<any> {
  if (process.env.NODE_ENV === 'development' && !USER_SERVICE_K8S_URL) {
    return { ...devUser, username, created_at: '2021-04-27T20:31:16Z' };
  }

  try {
    const userServiceUrl = `${USER_SERVICE_K8S_URL}/v1/services/users/${username}`;
    const response = await axios.get(userServiceUrl, userServiceHeaders);
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    let isLoggingError = true;
    if (typeof doNotLogError === 'function') {
      isLoggingError = !doNotLogError(e);
    } else {
      isLoggingError = !doNotLogError;
    }
    if (isLoggingError) {
      handleAxiosException(e);
    }
    // TODO: this is a temporary log for troubleshooting purposes
    return null;
  }
}

/**
 * Fetches users using version 2 of API
 */
export async function fetchUserV2(userId: string, doNotLogError: boolean | ((a: any) => boolean) = false): Promise<any> {
  if (process.env.NODE_ENV === 'development' && !USER_SERVICE_K8S_URL) {
    return { ...devUser, uuid: userId, id: undefined };
  }

  try {
    const userServiceUrl = `${USER_SERVICE_K8S_URL}/v2/services/users/${userId}`;
    const response = await axios.get(userServiceUrl, userServiceHeaders);
    return response.data;
  } catch (e: any) {
    let isLoggingError = false;
    if (typeof doNotLogError === 'function') {
      isLoggingError = doNotLogError(e);
    } else {
      isLoggingError = !!doNotLogError;
    }
    if (!isLoggingError) {
      handleAxiosException(e);
    }
    return null;
  }
}

export async function fetchOrganizationV1(orgId: any) {
  if (!orgId) {
    return null;
  }
  try {
    const organizationUrl = `${USER_SERVICE_K8S_URL}/v1/organizations/${orgId}`;
    const response = await axios.get(organizationUrl, userServiceHeaders);
    return response.data;
  } catch (e: any) {
    return null;
  }
}

export function isFreeUser(user: any): boolean {
  if (typeof user === 'string') {
    return user === USER_TYPES.FREE_TRIAL || user === USER_TYPES.FREEMIUM;
  }
  return user?.user_type === USER_TYPES.FREE_TRIAL || user?.user_type === USER_TYPES.FREEMIUM;
}

export function isServiceAccountUser(user: UserAuthenticationInfo) {
  return user?.roles?.includes('service_account');
}
